import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import PedidosList from "../../../components/PedidosList";
import PedidoDetails from "../../../components/PedidoDetails";
import PedidoNew from "../../../components/PedidoNew";

const useStyles = makeStyles(theme => ({
  container: {
    height: "100vh"
  },
  paper: {
    minHeight: "100%",
    backgroundColor: "#fafafa"
  }
}));

const Pedidos = ({ tipo }) => {
  const classes = useStyles();
  const [pedido, setPedido] = useState(null);
  const [nuevoPedido, setNuevoPedido] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(null);

  const vistaNuevoPedido = value => {
    setPedido(null);
    setNuevoPedido(value);
  };

  const vistaPedido = value => {
    setNuevoPedido(null);
    setPedido(value);
  };

  const handleCreate = () => {
    setNuevoPedido(null);
    setPedido(null);
    setShouldFetch(new Date().toString());
  };

  return (
    <Grid container className={classes.container}>
      <Grid item md={5}>
        <Paper className={classes.paper} square>
          <PedidosList
            tipo={tipo}
            selected={pedido}
            onSelect={vistaPedido}
            onNuevoPedido={vistaNuevoPedido}
            shouldFetch={shouldFetch}
          />
        </Paper>
      </Grid>

      {pedido && (
        <Grid item md={7}>
          <Paper className={classes.paper} square>
            <PedidoDetails
              pedido={typeof pedido === "string" ? null : pedido}
              onUpdate={setPedido}
            />
          </Paper>
        </Grid>
      )}

      {nuevoPedido && (
        <Grid item md={7}>
          <Paper className={classes.paper} square>
            <PedidoNew onCreate={handleCreate} />
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

export default Pedidos;
